// frontend/src/components/FinanceReport/Accounting/allocations/AllocationsTable.jsx
import React from "react";
import AllocationRow from "./AllocationRow";
import CommissionRow from "./CommissionRow";
import AddRow from "./AddRow";

export default function AllocationsTable({
  paymentId,
  tableRows,
  allocationsCount,
  commissionsCount,
  currenciesById,
  accountsById,
  paymentCurrency,
  onDeleteAllocation,
  onDeleteCommission,
  onOpenDocs,
  clientOrders,
  ordersByCode,
  currencies,
  accounts,
  addType,
  setAddType,
  addDraft,
  setAddField,
  addSaving,
  addError,
  onAdd,
  editingKind,
  editingId,
  editDraft,
  setEditDraft,
  editError,
  editSaving,
  onStartEditAllocation,
  onStartEditCommission,
  onSaveEdit,
  onCancelEdit,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white">
      <div className="border-b border-slate-200 px-5 py-3">
        <h2 className="text-lg font-bold text-slate-900">
          Распределения платежа
        </h2>
        <p className="mt-0.5 text-xs text-slate-500">
          Всего: {tableRows.length} · платежи фабрике: {allocationsCount} ·
          комиссии: {commissionsCount}
          <span className="ml-2 text-slate-400">
            клик по строке платежа фабрике → распределение по заказам
          </span>
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gray-100 text-left text-xs uppercase tracking-wide text-slate-600">
              <th className="border p-2">Дата</th>
              <th className="border p-2">Тип</th>
              <th className="border p-2">Заказ</th>
              <th className="border p-2">Счёт</th>
              <th className="border p-2">Сумма</th>
              <th className="border p-2">Распределение</th>
              <th className="border p-2">Статус</th>
              <th className="border p-2">Комментарий</th>
              <th className="border p-2">Платёж через</th>
              <th className="border p-2">Документы</th>
              <th className="border p-2">Действия</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.length === 0 && (
              <tr>
                <td
                  colSpan={11}
                  className="border p-8 text-center text-slate-500"
                >
                  Назначений и комиссий пока нет. Добавьте первое ниже.
                </td>
              </tr>
            )}

            {tableRows.map((row) => {
              if (row.kind === "commission") {
                const c = row.data;
                return (
                  <CommissionRow
                    key={row.id}
                    commission={c}
                    currenciesById={currenciesById}
                    accountsById={accountsById}
                    paymentCurrency={paymentCurrency}
                    isEditing={
                      editingKind === "commission" &&
                      String(editingId) === String(c.id)
                    }
                    editDraft={editDraft}
                    setEditDraft={setEditDraft}
                    editError={editError}
                    editSaving={editSaving}
                    clientOrders={clientOrders}
                    currencies={currencies}
                    accounts={accounts}
                    onStartEdit={onStartEditCommission}
                    onSaveEdit={onSaveEdit}
                    onCancelEdit={onCancelEdit}
                    onDelete={onDeleteCommission}
                    onOpenDocs={onOpenDocs}
                  />
                );
              }

              return (
                <AllocationRow
                  key={row.id}
                  breakdown={row.data}
                  currenciesById={currenciesById}
                  paymentCurrency={paymentCurrency}
                  paymentId={paymentId}
                  isEditing={
                    editingKind === "allocation" &&
                    String(editingId) === String(row.data.raw.id)
                  }
                  editDraft={editDraft}
                  setEditDraft={setEditDraft}
                  editError={editError}
                  editSaving={editSaving}
                  clientOrders={clientOrders}
                  currencies={currencies}
                  onStartEdit={onStartEditAllocation}
                  onSaveEdit={onSaveEdit}
                  onCancelEdit={onCancelEdit}
                  onDelete={onDeleteAllocation}
                  onOpenDocs={onOpenDocs}
                />
              );
            })}

            <AddRow
              addType={addType}
              setAddType={setAddType}
              addDraft={addDraft}
              setAddField={setAddField}
              addSaving={addSaving}
              onAdd={onAdd}
              clientOrders={clientOrders}
              ordersByCode={ordersByCode}
              currencies={currencies}
              accounts={accounts}
            />
          </tbody>
        </table>
      </div>

      {addError && (
        <div className="border-t border-red-200 bg-red-50 px-4 py-2 text-xs text-red-700">
          {addError}
        </div>
      )}
    </section>
  );
}